import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { mouseTrap } from "react-mousetrap"
import { Paragraph, CardStyle, Button } from "buoy-core"
import { responsive, colors } from "buoy-theme"
import Source from "../Source"
import InterviewSource from "../../interview/Source"
import Completion from "../../completion"
import CompletionSelectors from "./CompletionSelectors"
import * as CompletionActions from "../../completion/actions"
import * as IntegrationActions from "../../integration/actions"
import { getFollowUpOptions } from "../../feedback/actions"
import { ButtonContainer, CardHeading } from "../../account/components/CollapsibleFormCard"

const OuterContainer = styled.div`
  ${responsive("margin-top", "150px", "150px", "90px", "90px", "90px")};
  ${responsive("padding", "0px 200px", "0px 100px", "0px 50px", "0px 50px", "0px 20px")};
  min-height: 600px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const DevCard = styled.section`
  ${CardStyle};
  display: flex;
  flex-direction: column;
  position: relative;
  ${responsive("max-width", "704px", "704px", "640px", "640px", "640px")}
  max-width: 704px;
  width: 100%;
`

const Error = styled(Paragraph)`
  color: ${colors.error};
  bottom: unset;
  margin: 20px auto -15px;
  font-size: 15px;
`

const Dev = props => {
  return (
    <OuterContainer>
      <DevCard>
        <CardHeading>Completion Shortcut</CardHeading>
        <CompletionSelectors {...props} />
        <ButtonContainer>
          <Button onClick={props.submitSelectors}>Submit</Button>
        </ButtonContainer>
        {props.showError && <Error>{props.errorMsg}</Error>}
      </DevCard>
      {props.showCompletion && <Completion style={{ margin: "0 auto" }} />}
    </OuterContainer>
  )
}

class DevContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      adzerk: "",
      brand: "",
      diagnosis: "3047",
      postal: "",
      time: "",
      showCompletion: false,
      showError: false,
      errorMsg: "",
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  onChangeInput = field => e => this.setState({ [field]: e.target.value })

  onChangeDropdown = field => e => this.setState({ [field]: e })

  handleSubmit = () => {
    this.setState({ showCompletion: false, showError: false })
    Source.visitFromDiagnosis(this.state.diagnosis)
      .then(data => {
        this.getCompletion(data.visit)
        this.getRecommendations(data.visit)
        this.props.setZip(this.state.postal)
      })
      .catch(error => {
        console.log(error)
        this.setState({
          showError: true,
          errorMsg: "Error fetching visit from given diagnosis.",
        })
      })
  }

  getCompletion = token => {
    InterviewSource.results(token)
      .then(data => {
        this.props.setFollowUp()
        this.props.setResults(data.results)
        this.setState({ showCompletion: true })
      })
      .catch(error => {
        console.log(error)
        this.setState({
          showError: true,
          errorMsg: "Error fetching visit results.",
        })
      })
  }

  getRecommendations = token => {
    this.props.setRecommendations([])
    const options = {
      adzerk: this.state.adzerk || "false",
      postal: this.state.postal || undefined,
      time: this.state.time || undefined,
      brand: this.state.brand || "Buoy",
      token: token,
    }
    Source.getRecommendations(options)
      .then(data => {
        this.props.setRecommendations(data.recommendations)
      })
      .catch(error => {
        console.log(error)
        this.setState({
          showError: true,
          errorMsg: "Error fetching visit recommendations.",
        })
      })
  }

  render() {
    return (
      <Dev
        selectedDiagnosis={this.state.diagnosis}
        onChangeInput={this.onChangeInput}
        onChangeDropdown={this.onChangeDropdown}
        onSelectDiagnosis={this.handleChangeDiagnosis}
        postal={this.state.postal}
        onChangePostal={this.handleChangePostal}
        time={this.state.time}
        adzerk={this.state.adzerk}
        onChangeTime={this.handleChangeTime}
        selectedBrand={this.state.brand}
        onSelectBrand={this.handleChangeBrand}
        submitSelectors={this.handleSubmit}
        showCompletion={this.state.showCompletion}
        showError={this.state.showError}
        errorMsg={this.state.errorMsg}
      />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  setResults: results => {
    dispatch(CompletionActions.setResults(results))
  },
  setZip: zip => {
    dispatch(IntegrationActions.setZipcode(zip))
  },
  setRecommendations: recommendations => {
    dispatch(IntegrationActions.setRecommendations(recommendations))
  },
  setFollowUp: () => {
    dispatch(getFollowUpOptions())
  },
})

DevContainer = connect(null, mapDispatchToProps)(mouseTrap(DevContainer))

export { DevContainer as default }



// WEBPACK FOOTER //
// ./assets/dev/components/Dev.js